module.exports = __webpack_public_path__ + "assets/retina_SquareInTriangleDetailed.e44cf2a436d166320f341cad0f4444dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareInTriangleDetailed.png
// module id = 724
// module chunks = 0